export default __webpack_public_path__ + "static/media/image-default.8e7ae6ec.svg";